export default __webpack_public_path__ + "static/media/open-arrow.bd22dc47.svg";